var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"subtitle-2 mb-8",attrs:{"justify":"center"}},_vm._l((_vm.items),function(ref,i){
var icon = ref.icon;
var data = ref.data;
return _c('v-col',{key:i,staticClass:"pa-4",attrs:{"cols":"auto"}},[_c('v-row',{attrs:{"align":"center"}},[(icon)?_c('v-col',{attrs:{"cols":"auto"}},[_c('v-icon',[_vm._v(_vm._s(icon))])],1):_vm._e(),_c('v-col',{staticClass:"pa-4",attrs:{"cols":"auto"}},_vm._l((data),function(ref,j){
var text = ref.text;
var value = ref.value;
return _c('v-row',{key:j,attrs:{"justify":"space-between"}},[_c('v-col',{staticClass:"py-0",attrs:{"cols":"auto"}},[_vm._v(_vm._s(text))]),_c('v-col',{staticClass:"py-0",attrs:{"cols":"auto"}},[_vm._v(_vm._s(value))])],1)}),1)],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }